import Vue from 'vue';
import Vuex from 'vuex';
 
Vue.use(Vuex);
 
const store = new Vuex.Store({
  state: {
    // 是否登录
    isLogin: '',
  },
  mutations: {
      // 增加nutations属性
      setIsLogin(state, data) {
        // 增加一个mutations的方法，方法的作用是让num从0变成5，state是必须默认参数
        state.isLogin = data;
      }
  }

});
 
export default store;